import { Component, Show } from 'solid-js';

export interface SpinnerProps {
  show: boolean;
  message?: string;
  class?: string;
}

const Spinner: Component<SpinnerProps> = (props) => {
  return (
    <Show when={props.show}>
      <div class={`empty ${props.class ?? ''}`} data-cy="spinner">
        <div class="center">
          <i class="icon-font tc-icon-spinner-dark" />
          <Show when={props.message}>
            <div class="text-meta ml-1">{props.message}</div>
          </Show>
        </div>
      </div>
    </Show>
  );
};

export default Spinner;
